import React from "react";
import PropTypes from "prop-types";
import { pricesDiscount } from "components/Icon";
import Typography from "components/Typography";
import classes from "./PricesDiscountNotification.module.css";
import cn from 'classnames';

export const PricesDiscountNotification = ({ className = "" }) => (
  <div className={cn(className, classes.pricesDiscountNotification)}>
    <div className={classes.pricesDiscountNotificationContent}>
      <div className={classes.pricesDiscountNotificationImg}>
        {pricesDiscount}
      </div>
      <Typography variant="body" size="l" className={classes.pricesDiscountNotificationTitle}>Prices include all fees</Typography>
    </div>
  </div>
);

PricesDiscountNotification.propTypes = {
  className: PropTypes.string
};

